import { createFileRoute } from '@tanstack/react-router'

// The leaf that makes the pathless `_list` layout match on bare `/account/api/$appId/companies`; it renders nothing.
export const Route = createFileRoute('/_app/account/api/$appId/companies/_list/')({})
